export default (res, arr, set) => {
  const { id, is_locked } = res;
  const updated = arr.map((key) =>
    id === key.id ? { ...key, is_locked } : key
  );

  set(updated);
};
